const guidePriorityCohortMs = 6 * 60 * 60 * 1_000;

function waitingTimestamp(value: string | undefined): number {
  if (!value) return Number.POSITIVE_INFINITY;
  const parsed = Date.parse(value);
  return Number.isNaN(parsed) ? Number.POSITIVE_INFINITY : parsed;
}

/**
 * Preserve assignment and claim ordering outside this helper. Within an
 * equivalent route, age remains authoritative across six-hour cohorts while
 * a current authored guide wins inside the cohort. That gives authors a real
 * incentive without letting guided newcomers starve materially older work.
 */
export function compareGuideAwareReadiness(
  leftWaitingSince: string | undefined,
  rightWaitingSince: string | undefined,
  leftGuided: boolean,
  rightGuided: boolean,
): number {
  const leftWait = waitingTimestamp(leftWaitingSince);
  const rightWait = waitingTimestamp(rightWaitingSince);
  if (leftWait !== rightWait) {
    if (!Number.isFinite(leftWait)) return 1;
    if (!Number.isFinite(rightWait)) return -1;
    const cohortOrder = Math.floor(leftWait / guidePriorityCohortMs) - Math.floor(rightWait / guidePriorityCohortMs);
    if (cohortOrder !== 0) return cohortOrder;
  }

  const guideOrder = Number(rightGuided) - Number(leftGuided);
  if (guideOrder !== 0) return guideOrder;
  return leftWait === rightWait ? 0 : leftWait - rightWait;
}
